module.exports = __webpack_public_path__ + "img/button_rule.0c173135.png";